// extracted by mini-css-extract-plugin
export default {"patients":"PatientList_patients__yQHPj","nextPageSpinnerContainer":"PatientList_nextPageSpinnerContainer__FWJ2V"};